
function Image(props) {
    let data = props.data;
    data = {
        src: data && data.hasOwnProperty("src") ? data.src : "",
        alt: data && data.hasOwnProperty("alt") ? data.alt : "",
        width: data && data.hasOwnProperty("width") ? data.width : "",
        height: data && data.hasOwnProperty("height") ? data.height : "",
    };
    return <img src={data.src} alt={data.alt} className={data.classList} width={data.width} height={data.height} />
}

export default Image;